module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-8.05a34e9d.jpg";